<script lang="ts">
  export let color = '#000000';
</script>

<div class="color-picker">
  <label style="background-color: {color};">
    <input type="color" bind:value={color} />
  </label>
  <input type="text" bind:value={color} />
</div>

<style lang="scss">
  .color-picker {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;

    &:first-child input[type='text'] {
      border-left: none;
    }

    label {
      display: block;
      flex: 1;
    }

    input[type='color'] {
      visibility: hidden;
    }

    input[type='text'] {
      width: 100%;
      text-align: center;
      align-self: center;
      border-left: 1px solid var(--theme-text-fields-border);
    }
  }
</style>
